import styled from 'styled-components'
import { Swiper } from 'swiper/react'
import { GRADIENT, SPACE, Z_INDEX } from 'Theme'

export const StyledSwiper = styled(Swiper).withConfig({
  shouldForwardProp: (prop) => !['isBeginning', 'isEnd'].includes(prop),
})`
  max-height: 45vh;
  width: 100%;
  user-select: none;
  position: relative;
  ${({ isBeginning }) =>
    !isBeginning &&
    `
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: ${SPACE.PX_32};
      z-index: ${Z_INDEX.OVERLAY};
      background: linear-gradient(${GRADIENT.SWIPER_GRADIENT_TOP});
    }
  `}
  ${({ isEnd }) =>
    !isEnd &&
    `
    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: ${SPACE.PX_32};
      z-index: ${Z_INDEX.OVERLAY};
      background: linear-gradient(${GRADIENT.SWIPER_GRADIENT_BOTTOM});
    }
  `}
`
